"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantUpdateSuggestionRequest = instanceOfVariantUpdateSuggestionRequest;
exports.VariantUpdateSuggestionRequestFromJSON = VariantUpdateSuggestionRequestFromJSON;
exports.VariantUpdateSuggestionRequestFromJSONTyped = VariantUpdateSuggestionRequestFromJSONTyped;
exports.VariantUpdateSuggestionRequestToJSON = VariantUpdateSuggestionRequestToJSON;
exports.VariantUpdateSuggestionRequestToJSONTyped = VariantUpdateSuggestionRequestToJSONTyped;
const kindEnum_1 = require("./kindEnum");
const variantInVariantUpdateSuggestionRequest_1 = require("./variantInVariantUpdateSuggestionRequest");
/**
 * Check if a given object implements the VariantUpdateSuggestionRequest interface.
 */
function instanceOfVariantUpdateSuggestionRequest(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('issue' in value) || value['issue'] === undefined)
        return false;
    return true;
}
function VariantUpdateSuggestionRequestFromJSON(json) {
    return VariantUpdateSuggestionRequestFromJSONTyped(json, false);
}
function VariantUpdateSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': (0, kindEnum_1.KindEnumFromJSON)(json['kind']),
        'variants': json['variants'] == null ? undefined : (json['variants'].map(variantInVariantUpdateSuggestionRequest_1.VariantInVariantUpdateSuggestionRequestFromJSON)),
        'issue': json['issue'],
        'solution': json['solution'] == null ? undefined : json['solution'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function VariantUpdateSuggestionRequestToJSON(json) {
    return VariantUpdateSuggestionRequestToJSONTyped(json, false);
}
function VariantUpdateSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'kind': (0, kindEnum_1.KindEnumToJSON)(value['kind']),
        'variants': value['variants'] == null ? undefined : (value['variants'].map(variantInVariantUpdateSuggestionRequest_1.VariantInVariantUpdateSuggestionRequestToJSON)),
        'issue': value['issue'],
        'solution': value['solution'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=variantUpdateSuggestionRequest.js.map